import _ from 'lodash';

import { IconArrowLeft, IconArrowRight } from '@tock/icons';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { core } from '@tock/coretypes';
import DestinationCard from './DestinationCard';
import Slider from 'react-slick';
import SvgIconArrowLeft from 'components/icons/svgr/SvgIconArrowLeft';
import SvgIconArrowRight from 'components/icons/svgr/SvgIconArrowRight';
import clsx from 'clsx';

interface Props {
  destinations: core.IMetroArea[];
}

const DestinationsScroller = ({ destinations }: Props) => {
  const destinationCards = destinations.map((destination) => {
    return (
      <DestinationCard
        key={destination.id || undefined}
        destination={destination}
        onClick={_.noop}
      />
    );
  });
  return (
    <div className="Destination-section">
      <Slider
        dots={false}
        draggable={true}
        infinite={false}
        speed={500}
        slidesToShow={4}
        slidesToScroll={4}
        nextArrow={<NextArrow />}
        prevArrow={<PrevArrow />}
        responsive={[
          {
            breakpoint: 719,
            settings: {
              arrows: false,
              slidesToShow: 2.1,
              slidesToScroll: 2,
            },
          },
        ]}
      >
        {destinationCards}
      </Slider>
      <br />
    </div>
  );
};

// these parameters are provided by react-slick
interface ArrowProps {
  onClick?(): void;
  className?: string;
}

const NextArrow = ({ onClick, className }: ArrowProps) => {
  const arrowClassName = clsx('DestinationsScroller-arrow-container', className);
  return onClick ? (
    <div
      role="button"
      aria-label="Next destination"
      tabIndex={0}
      className={arrowClassName}
      onClick={onClick}
    >
      <IconMigrationUtil
        legacyIcon={<SvgIconArrowRight className="DestinationsScroller-arrow-right" />}
        newIcon={<IconArrowRight className="DestinationsScroller-arrow-right" />}
      />
    </div>
  ) : null;
};

const PrevArrow = ({ onClick, className }: ArrowProps) => {
  const arrowClassName = clsx('DestinationsScroller-arrow-container', className);
  return onClick ? (
    <div
      role="button"
      aria-label="Previous destination"
      tabIndex={0}
      className={arrowClassName}
      onClick={onClick}
    >
      <IconMigrationUtil
        legacyIcon={<SvgIconArrowLeft className="DestinationsScroller-arrow-left" />}
        newIcon={<IconArrowLeft className="DestinationsScroller-arrow-left" />}
      />
    </div>
  ) : null;
};

export default DestinationsScroller;
